import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { hasSource as t } from "../../../RasterBitmap.js";
import e from "../../VertexStream.js";
import r from "../WGLBrush.js";
import { setTextures as s, getCommonUniforms as a, setUniforms as i, getColormapUniforms as o, getStretchUniforms as n, getShadedReliefUniforms as h, getUniformLocationInfos as l, getBasicGridUniforms as c } from "../../../../../webgl/rasterUtils.js";

var d = /*#__PURE__*/function (_r) {
  _inherits(d, _r);

  var _super = _createSuper(d);

  function d() {
    var _this;

    _classCallCheck(this, d);

    _this = _super.apply(this, arguments), _this._desc = {
      lut: {
        vsPath: "raster/lut",
        fsPath: "raster/lut",
        attributes: new Map([["a_position", 0], ["a_texcoord", 1]])
      },
      stretch: {
        vsPath: "raster/stretch",
        fsPath: "raster/stretch",
        attributes: new Map([["a_position", 0], ["a_texcoord", 1]])
      },
      hillshade: {
        vsPath: "raster/hillshade",
        fsPath: "raster/hillshade",
        attributes: new Map([["a_position", 0], ["a_texcoord", 1]])
      }
    }, _this._rendererUniformInfos = new Map();
    return _this;
  }

  _createClass(d, [{
    key: "dispose",
    value: function dispose() {
      this._quad && this._quad.dispose();
    }
  }, {
    key: "prepareState",
    value: function prepareState(_ref, e) {
      var t = _ref.context;
      t.setBlendingEnabled(!0), t.setBlendFunctionSeparate(1, 771, 1, 771), t.setColorMask(!0, !0, !0, !0), t.setStencilWriteMask(0), t.setStencilTestEnabled(!0), t.setStencilFunction(514, e.stencilRef, 255);
    }
  }, {
    key: "draw",
    value: function draw(e, r) {
      var s;
      if (!t(r) || r.suspended) return;
      e.timeline.begin(this.name);
      var a = !(null != (s = e.context.capabilities.textureFloat) && s.textureFloatLinear);
      r.updateTexture(e);
      var i = this.getShaderVariations(r, a),
          o = e.painter.materialManager.getProgram(e, this._desc[r.symbolizerParameters.type], i);
      this.drawWithProgram(e.context, o, r), e.timeline.end(this.name);
    }
  }, {
    key: "drawWithProgram",
    value: function drawWithProgram(t, r, l) {
      var _d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      var p = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [0, 0];
      var u = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
      this._quad || (this._quad = new e(t, [0, 0, 1, 0, 0, 1, 1, 1]));
      var m = l.symbolizerParameters,
          f = l.transformGrid,
          g = l.width,
          _ = l.height,
          b = l.opacity,
          x = m.type;
      t.useProgram(r);

      var P = this.getShaderVariations(l),
          w = this.getUniformInfos(x, t, r, P),
          _l$getTextures = l.getTextures(),
          S = _l$getTextures.names,
          y = _l$getTextures.textures;

      s(t, r, S, y);
      var M = c(_d, p),
          U = a(f, [g, _], [l.source.width, l.source.height], b, u);

      if (i(r, w, _objectSpread(_objectSpread({
        u_coordScale: l.coordScale,
        u_dvsMat3: l.transforms.dvs
      }, M), U)), m.colormap) {
        var _t = m.colormap,
            _e = m.colormapOffset,
            _s = o(_t, _e);

        i(r, w, _s);
      }

      if ("stretch" === m.type) {
        var _t2 = n(m);

        i(r, w, _t2);
      } else if ("hillshade" === m.type) {
        var _t3 = h(m);

        i(r, w, _t3);
      }

      this._quad.draw();
    }
  }, {
    key: "getUniformInfos",
    value: function getUniformInfos(t, e, r, s) {
      var a = s.length > 0 ? t + "-" + s.join("-") : t;
      if (this._rendererUniformInfos.has(a)) return this._rendererUniformInfos.get(a);
      var i = l(e, r);
      return this._rendererUniformInfos.set(a, i), i;
    }
  }, {
    key: "getShaderVariations",
    value: function getShaderVariations(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var r = [],
          s = t.interpolation,
          _t$symbolizerParamete = t.symbolizerParameters,
          a = _t$symbolizerParamete.type,
          i = _t$symbolizerParamete.colormap;
      return "cubic" === s ? r.push("bicubic") : "bilinear" === s && "stretch" === a && null != i ? (r.push("bilinear"), r.push("nnedge")) : e && "bilinear" === s && r.push("bilinear"), t.isRendereredSource ? r.push("noop") : i && r.push("applyColormap"), t.transformGrid && r.push("applyProjection"), r;
    }
  }]);

  return d;
}(r);

export { d as default };